import React, { useState } from 'react';
import { Route, Switch } from 'react-router-dom';

import { Layout } from 'antd';

import HomeScreen from '../Home/HomeScreen';
import CompanyViewScreen from '../Company/CompanyViewScreen';
import CompanyAddScreen from '../Company/CompanyAddScreen';
import CompanyEditScreen from '../Company/CompanyEditScreen';
import CompanySettingScreen from '../CompanySetting/CompanySettingScreen';
import StationViewScreen from '../Station/StationViewScreen';
import StationAddScreen from '../Station/StationAddScreen';
import StationEditScreen from '../Station/StationEditScreen';
import StationSettingScreen from '../StationSetting/StationSettingScreen';
import StationDashboardScreen from '../StationDashboard/StationDashboardScreen';
import FarmSiteViewScreen from '../FarmSite/FarmSiteViewScreen';
import FarmSiteAddScreen from '../FarmSite/FarmSiteAddScreen';
import FarmSiteEditScreen from '../FarmSite/FarmSiteEditScreen';
import FarmSiteStationEditScreen from '../FarmSite/FarmSiteStationEditScreen';
import FarmSiteDashboardScreen from '../FarmSiteDashboard/FarmSiteDashboardScreen';
import FarmCropViewScreen from '../FarmCrop/FarmCropViewScreen';
import FarmCropAddScreen from '../FarmCrop/FarmCropAddScreen';
import FarmCropEditScreen from '../FarmCrop/FarmCropEditScreen';
import FarmProductionRecordViewScreen from '../FarmProductionRecord/FarmProductionRecordViewScreen';
import FarmProductionRecordAddSowScreen from '../FarmProductionRecord/FarmProductionRecordAddSowScreen';
import FarmProductionRecordAddTransplantScreen from '../FarmProductionRecord/FarmProductionRecordAddTransplantScreen';
import FarmProductionRecordAddHarvestScreen from '../FarmProductionRecord/FarmProductionRecordAddHarvestScreen';
import FarmProductionRecordAddWasteScreen from '../FarmProductionRecord/FarmProductionRecordAddWasteScreen';
import FarmProductionRecordEditScreen from '../FarmProductionRecord/FarmProductionRecordEditScreen';
import UserViewScreen from '../User/UserViewScreen';
import UserAddScreen from '../User/UserAddScreen';
import UserEditScreen from '../User/UserEditScreen';

const { Content } = Layout;

export default function AppContent(props) {
  return (
    <Content id="mainLayoutContent">
      <div>
        <Switch>
          <Route exact path="/company" component={CompanyViewScreen} />
          <Route exact path="/company/add" component={CompanyAddScreen} />
          <Route exact path="/company/edit/:companyId" component={CompanyEditScreen} />
          <Route exact path="/company/setting/:companyId" component={CompanySettingScreen} />
          <Route exact path="/station" component={StationViewScreen} />
          <Route exact path="/station/add" component={StationAddScreen} />
          <Route exact path="/station/edit/:stationId" component={StationEditScreen} />
          <Route exact path="/station/setting/:stationId" component={StationSettingScreen} />
          <Route exact path="/station/dashboard/:stationId" component={StationDashboardScreen} />
          <Route exact path="/farm-site" component={FarmSiteViewScreen} />
          <Route exact path="/farm-site/add" component={FarmSiteAddScreen} />
          <Route exact path="/farm-site/edit/:siteId" component={FarmSiteEditScreen} />
          <Route exact path="/farm-site/edit/:siteId/station/edit" component={FarmSiteStationEditScreen} />
          <Route exact path="/farm-site/dashboard/:siteId" component={FarmSiteDashboardScreen} />
          <Route exact path="/farm-crop" component={FarmCropViewScreen} />
          <Route exact path="/farm-crop/add" component={FarmCropAddScreen} />
          <Route exact path="/farm-crop/edit/:cropId" component={FarmCropEditScreen} />
          <Route exact path="/farm-production-record" component={FarmProductionRecordViewScreen} />
          <Route exact path="/farm-production-record/add/sow" component={FarmProductionRecordAddSowScreen} />
          <Route exact path="/farm-production-record/add/transplant" component={FarmProductionRecordAddTransplantScreen} />
          <Route exact path="/farm-production-record/add/harvest" component={FarmProductionRecordAddHarvestScreen} />
          <Route exact path="/farm-production-record/add/waste" component={FarmProductionRecordAddWasteScreen} />
          <Route exact path="/farm-production-record/edit/:recordId" component={FarmProductionRecordEditScreen} />
          <Route exact path="/user" component={UserViewScreen} />
          <Route exact path="/user/add" component={UserAddScreen} />
          <Route exact path="/user/edit/:userId" component={UserEditScreen} />
          <Route component={HomeScreen} />
        </Switch>
      </div>
    </Content>
  );
};
